@if (formFieldSignal(); as formField) {
    <div class="flex items-center gap-2">
        <input [ngClass]="{'hidden' : formField.IsHidden}" [class.error]="errorState?.AiValidationError === undefined && errorState != null"
               [class.errorYellow]="!formField.aiGeneration?.confirmed && formField.aiGeneration?.generated && errorState != null && errorState.AiValidationError"
               [formControl]="formControl" id="{{formField.Id}}" type="checkbox" kendoCheckBox/>

        @if (!isInGrid) {
            <label class="flex items-center justify-center gap-1 text-sm font-semibold" [for]="formField.Id">
            <span class="flex items-center gap-2" [innerHTML]="formField.Caption">
            </span>
                @if (formField.IsRequired) {
                    <span class="-top-0.5 h-5 text-xl leading-4 text-red-400">*</span>
                }
                @if (errorState?.AiValidationError === undefined && errorState?.Message; as errorMessage) {
                    <div class="z-[1] flex h-full items-center justify-center">
                        <bizz-tooltip class="relative -top-2 cursor-pointer text-red-400"
                                      [text]="errorMessage"></bizz-tooltip>
                    </div>
                }
                @if (formField.Hint) {
                    <bizz-popup class="ml-1" [title]="formField.Caption" [body]="formField.Hint"></bizz-popup>
                }
            </label>
        }
        @if (formField?.aiGeneration !== undefined) {
            @if (formField?.aiGeneration?.aiValue !== undefined) {
                @if (formField?.aiGeneration?.confirmed) {
                    <i class="fa-solid fa-microchip-ai ml-2 text-sm text-green-500"></i>
                } @else if (formField?.aiGeneration?.confirmed !== undefined) {
                    <i (click)="setAiButtonAcceptance(formField)"
                       class="fa-solid fa-microchip-ai ml-2 text-sm text-blue-500"></i>
                }
            } @else if (formField?.aiGeneration?.generated) {
                <bizz-tooltip
                        class="relative -top-2 inline-flex h-5 cursor-pointer text-xl leading-4 text-orange-400"
                        text="{{'AiCouldNotProcess' | translate }}"></bizz-tooltip>
            }
        }
    </div>
}